import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_ruleset4_PIQCV: string = `
case when v100LH >= ((Vmaxpos2 + Vmaxpos3) / 2) then 2 else 1 end as rank,
id, label, attributes`;

export const order_ruleset4_PIQCV = 'VnomLS, label';

const getAttributes = (rawName: string) => ({
    Vmaxpos1: `$.548.${rawName}`,
    Vmaxpos2: `$.549.${rawName}`,
    Vmaxpos3: `$.7311.${rawName}`,
    Vmaxpos4: `$.8669.${rawName}`,
    Vmaxpos5: `$.8670.${rawName}`,
    Vmaxpos6: `$.8671.${rawName}`,
    Vmaxpos7: `$.8672.${rawName}`,
    Vmaxpos8: `$.8673.${rawName}`,
    Vmaxpos9: `$.8674.${rawName}`,
    Vmaxpos10: `$.8675.${rawName}`,
    Vmaxpos11: `$.8676.${rawName}`,
    Vmaxpos12: `$.8677.${rawName}`,
    Vmaxpos13: `$.8678.${rawName}`,
    Vmaxpos14: `$.8679.${rawName}`,
    Vmaxpos15: `$.8680.${rawName}`,
    vnom: `$.3460.${rawName}`,
});

export const buildQuery_ruleset4_PIQCV: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow
}): [string, string[]] => {
    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT 
               cast(ifnull(attrs.value, 0) as float) as VnomLS,
               cast(ifnull(Vmaxpos1attrs.value, 0) as float) as Vmaxpos1,
               cast(ifnull(Vmaxpos2attrs.value, 0) as float) as Vmaxpos2,
               cast(ifnull(Vmaxpos3attrs.value, 0) as float) as Vmaxpos3,
               product.id,
               label,
               attributes
        FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.vnom)}) as attrs
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.Vmaxpos1)}) as Vmaxpos1attrs
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.Vmaxpos2)}) as Vmaxpos2attrs
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', attrs.Vmaxpos3)}) as Vmaxpos3attrs
                    WHERE ${filter}
                    AND ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} in ('["Pressure-independent zone valve"]')
                    )
            ,user_input as (SELECT cast(? as float) as v100)
            ,bounds as (SELECT v100 * 1000 as v100LH, round(v100 * 1000 / 3.6) / 1000 as v100LS FROM user_input)
         SELECT ${selectFields}
         FROM products_filtered
         JOIN bounds
         WHERE Vmaxpos1 <= v100LH and v100LS <= VnomLS
        `,
        // @TODO support units for US 347  ^^^^^
        [volumetricFlow]
    ];
}
